module.exports = __webpack_public_path__ + "img/bird-far.be4d8f80.svg";